import { Typography } from "@mui/material";
import React, { useState }  from "react";
import QRCodeStyling from "qr-code-styling";
import config from "../../../../../config";
import { Button } from "../../../../../components/Button/Button";
import { IEmbed } from "../../embedsV2/interface";
import { IconAttachment, IconGoToTab } from "../../../../../utils/icons";

interface Props {
  embed: IEmbed;
  openSettings: () => void;
}

export function PreviewUrlPanel({ embed, openSettings }: Props) {
  const formatUrl = (url: any = "") => url?.replace(/ /g, "-").toLowerCase();
  const [isCopied, setIsCopied] = useState<boolean>();

  const formatSettings = (source: string, preview = false) => {
    let previewString = "";
    if (preview) previewString = "&preview=true";
    return `?source=${source}${previewString}`;
  };

  const formatLandingUrl = (source: string = "landing", preview = false) => {
    let previewString = "";
    if (preview) previewString = "&preview=true";
    return `${config.EMBED_HOST}/brands/${embed?.brand?.id}/${
      embed?.brand?.slug
    }-/landing/${embed?.id}/${formatUrl(embed?.name)}${formatSettings(
      source
    )}${previewString}`;
  };

  const onCopyUrlBtnClick = () => {
    navigator.clipboard.writeText(formatLandingUrl("landing"));
    setIsCopied(true);
    setTimeout(setIsCopied, 2000);
  };

  const makeBtn = (
    text: string,
    callback: any,
    icon?: JSX.Element,
    customClassName?: string
  ) => (
    <Button
      className={`!flex gap-2 !px-4 items-center justify-center ${customClassName}`}
      onClick={callback}
    >
      <Typography>{text}</Typography>
      {icon}
    </Button>
  );

  return (
    <div className="flex flex-col gap-2 justify-between h-full">
      <div className="p-6 flex flex-col w-full gap-4">
        <div className="p-4 bg-surface-2 rounded-md">
          <p
            style={{
              wordWrap: "break-word",
              fontFamily: "CircularStd",
            }}
          >
            {`${formatLandingUrl("landing", false)}`}
          </p>
        </div>
      </div>
      <div className="pt-4 flex items-center justify-end px-6 gap-2 border-t border-border-token">
        {makeBtn(
          isCopied ? "Copied!" : "Copy Video URL",
          onCopyUrlBtnClick,
          <IconAttachment stroke="#fff" />
        )}
        {makeBtn(
          "Preview Video",
          () => window.open(formatLandingUrl("landing", true), "_blank"),
          <IconGoToTab stroke="currentColor" />,
          "!text-text-1 !bg-surface-2"
        )}
      </div>
    </div>
  );
}
